import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link, Tooltip } from '@mui/material';
import { initialState } from 'features/auth/store';
import { useTranslation } from 'react-i18next';
import { redirectToOldPortal } from 'shared/utils/browserCompat';

import NavigationInternalButton from './NavigationInternalButton';

/**
 * FallbackLink Component
 *
 * Provides a manual user-initiated option to switch to the classic portal.
 * Always visible to give users choice, regardless of browser compatibility.
 *
 * Use cases:
 * - User prefers the old design
 * - User needs a specific feature only in classic version
 * - User experiencing issues with new version
 */
export default function FallbackLink() {
    const { t } = useTranslation('navigation');

    const handleClick = () => {
        redirectToOldPortal('manual-switch');
    };

    const candidateToken = initialState.accessToken?.token || initialState.accessToken?.oldAvailabilityToken;

    if (!candidateToken) {
        return null;
    }

    return (
        <Tooltip title={ t('fallback.tooltip') }>
            <NavigationInternalButton component={ Link }
                startIcon={ <OpenInNewIcon /> }
                onClick={ handleClick }
                aria-label={ t('fallback.tooltip') }
            >
                { t('fallback.label') }
            </NavigationInternalButton>
        </Tooltip>
    );
}
